import { IonRow, IonCol, IonIcon } from "@ionic/react";
import React, { useEffect, useState } from "react";
import { API_URL } from "../../../actions/settings";
import { starSharp } from "ionicons/icons";
import  { default as money_bag_icon }  from "../../../AE2/static/icons/money_bag_icon.svg";
import  { default as dollar }  from "../../../AE2/static/icons/dollar_icon.svg";
import  { default as carbon }  from "../../../AE2/static/icons/carbon_icon.svg";
import { default as solar } from "../../../AE2/static/icons/solar_icon.svg";

async function getData(token: string, id: string) {
  return fetch(`${API_URL}/customer/${id}/savings_overview`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      Authorization: token,
    },
  }).then((res) => {
    if (res.ok) {
      return res.json();
    } else {
      return false;
    }
  });
}


interface Props {
  id:string
}

const OverviewSummary: React.FC<Props> = ({ id }) => {
  const [data, setData] = useState<any>({
    cost_avoidance:0,
    incentives:0,
    ghg:0,
    cars:0
  });
  const newUI = localStorage.getItem("newUI")?.toLowerCase() === 'true';

  useEffect(() => {
    const handleData = async () => {
      const token = localStorage.getItem("token") || "";
      const res = await getData(`Token ${token.slice(1, -1)}`, id);
      if (res) {
        setData(res.data);
      }
    };
    handleData();
  }, [id]);

  return (
    <IonRow style={{ height: "100%" }} className="overViewContainer">
      <IonCol size="12">
        <IonRow className="ion-justify-content-center ion-align-items-center"><IonIcon src={money_bag_icon} size="large"/> <h2 className={newUI?"text-dark-blue":''} >Energy Waste Avoided</h2> </IonRow>
        <div style={{ textAlign: "center" }}>${data.cost_avoidance.toLocaleString('en')}</div>
      </IonCol>
      <IonCol size="12">
      <IonRow className="ion-justify-content-center ion-align-items-center"><IonIcon src={dollar} size="large"/> <h2 className={newUI?"text-dark-blue":''} >Utility Grants Received</h2> </IonRow>
        <div style={{ textAlign: "center" }}>
          ${data.incentives.toLocaleString("en")}
        </div>
      </IonCol>
      <IonCol size="12">
      <IonRow className="ion-justify-content-center ion-align-items-center"><IonIcon src={starSharp} size="large"/> <h2 className={newUI?"text-dark-blue":''} >Energy Star Certified</h2> </IonRow>
        <div style={{ textAlign: "center" }}>{data.certification ? `${data.certification}%` : 'n/a'}</div>
      </IonCol>
      <IonCol size="12">
      <IonRow className="ion-justify-content-center ion-align-items-center"><IonIcon src={carbon} size="large"/> <h2 className={newUI?"text-dark-blue":''} >Carbon Emission Reduced</h2> </IonRow>
        <div style={{ textAlign: "center" }}>{data.ghg ? `${data.ghg.toLocaleString('en')}%` : 'n/a'}</div>
      </IonCol>
      <IonCol size="12">
      <IonRow className="ion-justify-content-center ion-align-items-center">
        <IonIcon src={solar} size="large"/>&nbsp;
        <div>
          <h2 style={{margin:0}} className={newUI?"text-dark-blue":''} > Equivalent Solar Panels</h2>
          <div  style={{textAlign:'center',fontSize:'12px'}}>(400W per 4' x 6' panel)</div>
        </div>  
        </IonRow>
      
        <div style={{ textAlign: "center" }}>{data.panels ? `${data.panels.toLocaleString('en')}` : 'n/a'}</div>
      </IonCol>
    </IonRow>
  );
};

export default OverviewSummary;
